import { styled } from "@mui/material/styles";

export const UnlockBackdrop = styled("div")({
  position: "fixed",
  inset: 0,
  background: "rgba(2,0,40,0.82)",
  backdropFilter: "blur(10px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1400,
  padding: 24,
  animation: "mp-fade-in 200ms ease-out",
});

export const UnlockPanel = styled("div")({
  position: "relative",
  width: "min(440px, 92vw)",
  background: "linear-gradient(180deg, #0F0B3E 0%, #07052A 100%)",
  border: "1px solid rgba(150,46,255,0.25)",
  borderRadius: 20,
  padding: "40px 36px 32px",
  boxShadow: "0 24px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(150,46,255,0.08)",
  animation: "mp-slide-up 350ms cubic-bezier(0.16,1,0.3,1)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 0,
  textAlign: "center",
});

export const UnlockCloseBtn = styled("button")({
  position: "absolute",
  top: 16,
  right: 16,
  width: 32,
  height: 32,
  borderRadius: "50%",
  background: "rgba(255,255,255,0.06)",
  border: "1px solid rgba(255,255,255,0.10)",
  color: "#D1C7FF",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "background 150ms",
  "&:hover": {
    background: "rgba(255,255,255,0.12)",
  },
});

export const UnlockIconRing = styled("div")({
  width: 64,
  height: 64,
  borderRadius: "50%",
  background: "linear-gradient(135deg, rgba(1,236,255,0.18), rgba(150,46,255,0.22))",
  border: "1px solid rgba(1,236,255,0.3)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 20,
});

export const UnlockTitle = styled("h2")({
  fontSize: 22,
  fontWeight: 700,
  color: "#FEFEFE",
  margin: "0 0 10px",
  fontFamily: "Poppins, sans-serif",
  lineHeight: 1.25,
});

export const UnlockBody = styled("p")({
  fontSize: 14,
  color: "#A87EFF",
  margin: "0 0 28px",
  lineHeight: 1.65,
  fontFamily: "Poppins, sans-serif",
});

export const UnlockConfirmBtn = styled("button")({
  width: "100%",
  height: 44,
  borderRadius: 10,
  background: "rgba(255,255,255,0.06)",
  border: "1px solid rgba(255,255,255,0.14)",
  color: "#D1C7FF",
  fontSize: 14,
  fontWeight: 600,
  fontFamily: "Poppins, sans-serif",
  cursor: "pointer",
  transition: "background 150ms, border-color 150ms",
  "&:hover": {
    background: "rgba(255,255,255,0.10)",
    borderColor: "rgba(255,255,255,0.24)",
  },
});
